module.exports = __webpack_public_path__ + "static/img/1.ee65b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/m/1.png
// module id = JZ2C
// module chunks = 1 2